
import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'

const validateInput = (e, callback) => {
  if(/[^-\d]/g.test(e.target.value))
    return

  callback(e)
}

const DateOfBirthInput = props => (
  <TextField 
    type="date"
    onChange={e => validateInput(e, props.onChange)}
    InputLabelProps={{ shrink: true }}
    {...props}
  />
)

DateOfBirthInput.propTypes = {
  onChange: PropTypes.func.isRequired
}

export default DateOfBirthInput


// WEBPACK FOOTER //
// ./src/components/common/DateOfBirthInput.js